module.exports = __webpack_public_path__ + "img/facebook.11b21e35.svg";